// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2IDOn","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2rLOK","gfeWrapper":"CalendarEvent_gfeWrapper__2_H35"};